import PropTypes from 'prop-types';
import React from 'react';
import {connect as connectR} from 'react-redux';
import {Col, Row} from 'react-bootstrap';
import _ from 'lodash';
import EditLargeCard from '../main/edit-large-card';
import LargeCard from '../main/large-card';
import LeftSide from '../main/left-side';
import Postit from '../main/postit';
import ApplianceBasicForm from './forms/appliance-basic-form';
import ApplianceStatusForm from './forms/appliance-status-form';
import translate from '../translate';
import VerticalNavigation from '../navigation/vertical-navigation';
import {CONTROL_TYPE} from '../../util/enums';
import {
    DeleteAppliance,
    LoadAppliancesByLocation,
    resetApplianceRequestStates,
    UpdateAppliance,
} from '../../store/applianceSlice';
import {LoadLocationsForMansionId} from '../../store/locationsSlice';
import {LoadConnectedSwitchSerialNumbers, LoadSwitchSerialNumbers} from '../../store/serialNumbersSlice';
import {REQUEST_FAILURE} from '../../store/network/managedRequest';
import {LoadMansions} from '../../store/mansionsSlice';
import InstallationVerificationForm from './forms/installation-verification-form';
import {goToLocation} from '../../nav/navigationService';
import ConfirmButton from '../util/confirm-button';
import {PbRequest} from '../../store/pbRequest';
import withParams from '../../nav/withParams';

const defaultFields = {
    state: 'OFFLINE',
    appliance_type: 'WASHING_MACHINE',
    location_id: '',
    local_name: '',
    short_name: '',
    control_type: CONTROL_TYPE.power,
    serial_number: '',
};

class EditAppliance extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        params: PropTypes.shape({
            appliance_id: PropTypes.string,
            location_id: PropTypes.string,
            object_id: PropTypes.string,
        }).isRequired,
        LoadAppliancesByLocation: PropTypes.func.isRequired,
        LoadSwitchSerialNumbers: PropTypes.func.isRequired,
        UpdateAppliance: PropTypes.func.isRequired,
        DeleteAppliance: PropTypes.func.isRequired,
        resetApplianceRequestStates: PropTypes.func.isRequired,
        appliancesByLaundryRoom: PropTypes.shape({}).isRequired,
        updateRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        LoadLocationsForMansionId: PropTypes.func.isRequired,
        locationsByMansionsById: PropTypes.shape({}).isRequired,
        LoadMansions: PropTypes.func.isRequired,
        mansionsById: PropTypes.shape({}).isRequired,
    };

    state = {
        appliance: undefined,
    };

    componentDidMount() {
        this.props.resetApplianceRequestStates();
        this.props.LoadSwitchSerialNumbers(
            Number(this.props.params.location_id)
        );
        this.props.LoadConnectedSwitchSerialNumbers(
            Number(this.props.params.location_id)
        );
        this.props.LoadAppliancesByLocation(
            Number(this.props.params.location_id)
        );
        this.props.LoadLocationsForMansionId(
            Number(this.props.params.object_id)
        );
        this.props.LoadMansions();
    }

    _handleDeleteSuccess = () => {
        goToLocation(
            Number(this.props.params.object_id),
            Number(this.props.params.location_id)
        );
    };

    _getAppliance = () => {
        const appliance = defaultFields;
        const locationId = Number(this.props.params.location_id);
        const applianceId = Number(this.props.params.appliance_id);
        if (locationId && applianceId) {
            const byApplianceId =
                this.props.appliancesByLaundryRoom[locationId] || {};
            const foundAppliance = byApplianceId[applianceId] || {};
            _.extend(appliance, foundAppliance);
        }
        return appliance;
    };

    _handleApplianceForm = (info) => {
        const appliance = _.extend(
            {},
            this._getAppliance(),
            this.state.appliance,
            {
                appliance_type: info.appliance_type,
                local_name: info.local_name,
                short_name: info.short_name,
                control_type: info.control_type,
                serial_number: info.serial_number,
                contractual_type: info.contractual_type,
                product_code: info.product_code,
                model_group: info.model_group,
                manufacturing_batch: info.manufacturing_batch,
            }
        );
        this.setState({ appliance: _.extend({}, appliance) });
        if (info._valid) {
            const locationId = Number(this.props.params.location_id);
            this.props.UpdateAppliance(appliance, () =>
                this.props.LoadSwitchSerialNumbers(locationId)
            );
        }
    };

    loadAppliance = () => {
        this.state.appliance = _.extend(
            this.state.appliance,
            this._getAppliance()
        );
    };

    render() {
        this.loadAppliance();
        const info = _.extend({}, this.state.appliance);
        const hasError = this.props.updateRequest.status === REQUEST_FAILURE;
        return (
            <Row>
                <LeftSide addClass="">
                    <VerticalNavigation
                        selected="objects"
                        selectedObject={parseInt(
                            this.props.params.object_id,
                            10
                        )}
                        objects={this.props.mansionsById}
                        selectedLocation={parseInt(
                            this.props.params.location_id,
                            10
                        )}
                        locations={this.props.locationsByMansionsById}
                        selectedAppliance={parseInt(
                            this.props.params.appliance_id,
                            10
                        )}
                        appliances={
                            this.props.appliancesByLaundryRoom[
                                parseInt(this.props.params.location_id, 10)
                            ]
                        }
                    />
                </LeftSide>
                <Col xs={9} sm={9} md={9} lg={9} className="col-middle">
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <LargeCard
                                type="card-info"
                                title={this.props.strings.status_title}
                            >
                                <ApplianceStatusForm
                                    applianceId={parseInt(
                                        this.props.params.appliance_id,
                                        10
                                    )}
                                    locationId={parseInt(
                                        this.props.params.location_id,
                                        10
                                    )}
                                />
                            </LargeCard>
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4}>
                            <Postit
                                title={this.props.strings.statusPostit.title}
                            >
                                <p>{this.props.strings.statusPostit.text1}</p>
                                <p>{this.props.strings.statusPostit.text2}</p>
                            </Postit>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <EditLargeCard
                                title={this.props.strings.headline}
                                handleSubmit={this._handleApplianceForm}
                                validationEnabled
                                submitLabel={this.props.strings.save}
                                error={hasError}
                                handleCancel={() => {
                                    this.props.LoadAppliancesByLocation(
                                        info.location_id
                                    );
                                }}
                            >
                                <ApplianceBasicForm
                                    info={info}
                                    forceValidation
                                    location_id={parseInt(
                                        this.props.params.location_id,
                                        10
                                    )}
                                />
                                <ConfirmButton
                                    danger
                                    onConfirmedAction={() =>
                                        this.props.DeleteAppliance(
                                            Number(
                                                this.props.params.appliance_id
                                            ),
                                            Number(
                                                this.props.params.location_id
                                            ),
                                            () => this._handleDeleteSuccess()
                                        )
                                    }
                                    linkClassName="icon icon-wew-trash icon-sm"
                                    confirmTitle={
                                        this.props.strings.deleteModal.title
                                    }
                                    confirmMessage={
                                        this.props.strings.deleteModal
                                            .description
                                    }
                                    confirmAction={
                                        this.props.strings.deleteModal.confirm
                                    }
                                    rejectAction={
                                        this.props.strings.deleteModal.cancel
                                    }
                                >
                                    <span
                                        className="btn btn-action"
                                        style={{
                                            marginLeft: '1em',
                                        }}
                                    >
                                        {this.props.strings.delete}
                                    </span>
                                </ConfirmButton>
                            </EditLargeCard>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <LargeCard
                                type="card-info"
                                title={
                                    this.props.strings
                                        .installationVerificationTitle
                                }
                            >
                                <InstallationVerificationForm
                                    applianceId={parseInt(
                                        this.props.params.appliance_id,
                                        10
                                    )}
                                    locationId={parseInt(
                                        this.props.params.location_id,
                                        10
                                    )}
                                />
                            </LargeCard>
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4}>
                            <Postit
                                title={
                                    this.props.strings.verificationCyclePostit
                                        .title
                                }
                            >
                                <p>
                                    {
                                        this.props.strings
                                            .verificationCyclePostit.text
                                    }
                                </p>
                            </Postit>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}

export default connectR(
    (store) => ({
        updateRequest: store.pbRequest[PbRequest.UPDATE_APPLIANCE],
        appliancesByLaundryRoom: store.appliance.appliancesByLaundryRoom,
        locationsByMansionsById: store.locations.locationsByMansionsById,
        mansionsById: store.mansions.mansionsById,
    }),
    {
        LoadAppliancesByLocation,
        LoadSwitchSerialNumbers,
        LoadConnectedSwitchSerialNumbers,
        UpdateAppliance,
        DeleteAppliance,
        resetApplianceRequestStates,
        LoadLocationsForMansionId,
        LoadMansions,
    }
)(translate('EditAppliance')(withParams(EditAppliance)));
